export type E2eeUnlockResult = { passphrase: string; remember: boolean; usePasskey?: boolean };

export type E2eeUnlockOptions = { title?: string; message?: string; showRememberOptions?: boolean };

type Handler = (opts?: E2eeUnlockOptions) => Promise<E2eeUnlockResult>;

let handler: Handler | null = null;

export function setE2eeUnlockHandler(h: Handler | null) {
  handler = h;
}

export async function requestE2eeUnlock(opts?: E2eeUnlockOptions): Promise<E2eeUnlockResult> {
  if (!handler) {
    // Fallback if modal host isn't mounted for some reason.
    const passphrase = window.prompt('Enter your encryption passphrase to decrypt this document.') || '';
    if (!passphrase.trim()) throw new Error('Missing passphrase');
    const showRememberOptions = opts?.showRememberOptions ?? true;
    const remember = showRememberOptions
      ? window.confirm('Remember encryption key on this device to avoid entering the passphrase again?')
      : false;
    return { passphrase, remember, usePasskey: false };
  }
  return await handler(opts);
}

